import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  public transform(value: any, key:string, term:string){
    if(value==null){
      return;
    }
    return value.filter((item:any) => {
      if (item.value.hasOwnProperty(key)) {
        if (term) {
          let regExp = new RegExp('\\b' + term, 'gi');
          let result = regExp.test(item.value[key]);
          return result;
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
  }

}
